import {BussinessLine, type BussinessLineData} from "@/types/site_admin/bussiness-lines";
import {CompanyFeature, type CompanyFeatureData} from "@/types/company/company-features";
import {CompanyNote, type CompanyNoteData} from "@/types/company/companyNote";
import {CompanyFile, type CompanyFileData} from "@/types/company/companyFile";
import {CompanyBillingMethod, type CompanyBillingMethodData} from "@/types/company/company-billing-methods";
import {TmsRole, type TmsRoleData} from "@/types/company/tms-roles";
import {CompanyTmsRole, type CompanyTmsRoleData} from "@/types/company/company-tms-roles";
import {CompanyBusinessLine, type CompanyBusinessLineData} from "@/types/company/CompanyBusinessLine";
import {Contact} from "@/types/contacts/contact";
import {UserToCompany, type UserToCompanyData} from "@/types/users/userToCompany";
import {UserToBusinessLine, type UserToBusinessLineData} from "@/types/users/userToBusinessLine";
import {
    InternationalRoadOrderEntry,
    type InternationalRoadOrderEntryData
} from "@/types/order-entry/InternationalRoadOrderEntry";
import {DomesticRoadOrderEntry, type DomesticRoadOrderEntryData} from "@/types/order-entry/DomesticRoadOrderEntry";
import {CompanyStrongoSetting, type CompanyStrongoSettingData} from "@/types/company/CompanyStrongoSetting";
import {StrongoOrderEntry, type StrongoOrderEntryData} from "@/types/order-entry/StrongoOrderEntry.ts";
import {OrderEntryLeadtime, type OrderEntryLeadtimeData} from "@/types/order-entry/OrderEntryLeadtime";
import {StrongoOrderEntryLeadtime, type StrongoOrderEntryLeadtimeData} from "@/types/order-entry/StrongoOrderEntryLeadtime";
import {StrongoDepartment, type StrongoDepartmentData} from "@/types/order-entry/StrongoDepartment";
import {OrderEntryEmail, type OrderEntryEmailData} from "@/types/order-entry/OrderEntryEmail";
import {CompanyContract, type CompanyContractData} from "@/types/company/CompanyContract";
import {User, type UserData} from "@/types/users/user";
import {CompanyBusinessLineDetail, type CompanyBusinessLineDetailData} from "@/types/company/CompanyBusinessLineDetail";
import {CompanyKpi, type CompanyKpiData} from "@/types/company/CompanyKpi";
import {CompanyAnnex, type CompanyAnnexData} from "@/types/company/CompanyAnnex.ts";
import {AccountReceivable,type AccountReceivableData} from "@/types/company/AccountReceivable.ts";
import {CustomerLedgerEntry, type CustomerLedgerEntryData} from "@/types/erp/customerLedgerEntry.ts";
import {TmsRoad,type TmsRoadData} from "@/types/company/system-sync/TmsRoadData.ts";
import {TmsSea,type TmsSeaData} from "@/types/company/system-sync/TmsSeaData.ts";
import {ERP,type ERPData} from "@/types/company/system-sync/ErpData.ts";
import {Strongo,type StrongoData} from "@/types/company/system-sync/StrongoData.ts";

export class Company {
    public id: number | null;
    public tms_road_unique_code: string | null;
    public tms_road_unique_fin_code: string | null;
    public blocked: number | null;
    public client_mcp_blocked: number | null;
    public erp_blocked_id: number | null;
    public allowed_modify: boolean;
    public responsibility_center_id: number | null;
    public do_not_block_until: Date | null;
    public do_not_block_from: Date | null;
    public blocking_reason: string;
    public name: string;
    public image_data: string | null;
    public address: string;
    public country: number | null;
    public city: string | null;
    public county: string | null;
    public sector: string;
    public telephone: string;
    public mobile: string;
    public email: string;
    public contact_person: string;
    public document_check_level_id: number | null;
    public language_id: number | null;
    public marketing_ratio_id: number | null;
    public initial_marketing_ratio_id: number | null;
    public sales_ratio_id: number | null;
    public key_account_manager_id: number | null;
    public status: number;
    public tms_road_api_status: number;
    public double_order_refs_allowed: number;
    public reference_mandatory: number;
    public bank_no: string;
    public bank_name: string;
    public zip_code: string;
    public swift: string;
    public bank_city_name: string;
    public iban: string;
    public fuel_surcharge_method_id: number | null;
    public sales_calculation_level_nd_shipment_id: number | null;
    public sales_calculation_level_ro_order_id: number | null;
    public consolidation_type_id: number | null;
    public company_financials_address: string;
    public company_financials_address2: string;
    public company_financials_zip_code: string;
    public company_financials_country: number;
    public company_financials_county: string | null;
    public company_financials_sector: string;
    public company_financials_city: string;
    public currency_id: number | null;
    public default_currency_id: number | null;
    public default_invoicing_exchange_id: number | null;
    public creditor_number: string;
    public financial_date_determination_id: number | null;
    public double_financials_ref_allowed: number;
    public request_debtor_no: number;
    public credit_check: number;
    public vat_country_code: string;
    public vat_number: string | null;
    public commerce_code: string;
    public invoice_expire_date_method_id: number | null;
    public invoice_expire_date_method_cr_id: number | null;
    public invoice_copies: number;
    public change_revenue_status_auto_to_toinv: number;
    public change_revenue_status_when_shipment_id: number | null;
    public print_specification: number;
    public pickup_delivery: number;
    public pickup: number;
    public transfer: number;
    public delivery: number;
    public nps: string | null;
    public created_by_user: string;
    public updated_by_user: string;
    public business_category_id: number | null;
    public industry_id: number | null;
    public parent_account_id: number | null;
    public website: string | null;
    public description: string | null;
    public company_type_id: number | null;
    public payment_term_id: number | null;
    public credit_limit: number | null;
    public credit_valute_id: number | null;
    public first_order_date: Date | null;
    public iff_first_order_date: Date | null;
    public sea_fcl_first_order_date: Date | null;
    public sea_lcl_first_order_date: Date | null;
    public air_first_order_date: Date | null;
    public distribution_first_order_date: Date | null;
    public strongo_first_order_date: Date | null;
    public logistics_first_order_date: Date | null;
    public simplify_first_order_date: Date | null;
    public due_date_type: number | null;
    public due_date_type_cr: number | null;
    public address2: string;
    public customer_reminder_email: string;
    public reminder_term_id: number | null;
    public role_id: number | null;
    public default_val: number;
    public partner_type_id: number | null;
    public d394_county_code_id: number | null;
    public saft_partner_type_id: number | null;
    public customer_posting_group_id: number | null;
    public vendor_posting_group_id: number | null;
    public customer_gen_bus_posting_group_id: number | null;
    public vendor_gen_bus_posting_group_id: number | null;
    public customer_vat_bus_posting_group_id: number | null;
    public vendor_vat_bus_posting_group_id: number | null;
    public application_method_id: number | null;
    public sales_persons_code_id: number | null;
    public vendor_send_payment_notif: number | null;
    public not_vat_registration: number | null;
    public applies_split_vatsys: number | null;
    public unrealized_vat_status: number | null;
    public customer_contract_no: string;
    public tms_sea_email: string;
    public tms_sea_telephone: string;
    public wms_email: string;
    public wms_telephone: string;
    public vbs_email: string;
    public vbs_telephone: string;
    public erp_email: string;
    public erp_telephone: string;
    public strongo_email: string;
    public strongo_telephone: string;
    public payment_method_id: number | null;
    public is_active: number | null;
    public ticketing_external_id: number | null;
    public sales_approved_at: Date | null;
    public financial_approved_at: Date | null;
    public international_order_entry: boolean;
    public domestic_order_entry: boolean;
    public strongo_order_entry: boolean;
    public disable_erp_duplicate: boolean;
    public transport_contract_enabled: boolean;
    public warehousing_contract_enabled: boolean;
    public image_contents:string;
    public image_type:string;
    public createdAt: Date | null;
    public updatedAt: Date | null;
    public bussinessLines: BussinessLine[];
    public tmsRoles: TmsRole[];
    public companyTmsRoles: CompanyTmsRole[];
    public companyFeatures: CompanyFeature[];
    public companyBillingMethods: CompanyBillingMethod[];
    public companyNotes: CompanyNote[];
    public companyFiles: CompanyFile[];
    public contacts: Contact[] | undefined;
    public companyBusinessLines: CompanyBusinessLine[];
    public companyBusinessLineDetails: CompanyBusinessLineDetail[];
    public userToCompanies: UserToCompany[];
    public userToBusinessLines: UserToBusinessLine[];
    public internationalRoadOrderEntry: InternationalRoadOrderEntry | undefined;
    public domesticRoadOrderEntry: DomesticRoadOrderEntry | undefined;
    public strongoOrderEntry: StrongoOrderEntry | undefined;
    public companyStrongoSetting: CompanyStrongoSetting;
    public orderEntryLeadtimes: OrderEntryLeadtime[];
    public strongoLeadtimes: StrongoOrderEntryLeadtime[];
    public strongoDepartments: StrongoDepartment[];
    public orderEntryEmails: OrderEntryEmail[];
    public companyContracts: CompanyContract[];
    public activeCompanyContracts: CompanyContract[];
    public companyKpis: CompanyKpi[];
    public companyAnnexes: CompanyAnnex[];
    public contractManagers: User[];
    public parentAccount: Company | null;
    public accountReceivable: AccountReceivable | null;
    public lastCustomerLedgerEntry: CustomerLedgerEntry | null;
    public salesPerson: User | null;
    public tmsRoadCreationDate: TmsRoad | null;
    public tmsSeaCreationDate: TmsSea | null;
    public erpCreationDate: ERP | null;
    public strongoCreationDate: Strongo | null;
    public lastPaymentNote: CompanyNote | null;


    constructor(data: CompanyData | undefined | null = undefined) {
        if (data === undefined || data === null) {
            this.id = null;
            this.tms_road_unique_code = null;
            this.tms_road_unique_fin_code = null;
            this.blocked = 0;
            this.client_mcp_blocked = 0;
            this.erp_blocked_id = 339;
            this.allowed_modify = false;
            this.responsibility_center_id = null;
            this.do_not_block_until = null;
            this.do_not_block_from = null;
            this.blocking_reason = "";
            this.name = "";
            this.image_data = null;
            this.address = "";
            this.country = null;
            this.city = "";
            this.zip_code = "";
            this.county = null;
            this.sector = "";
            this.telephone = "";
            this.mobile = "";
            this.email = "";
            this.contact_person = "";
            this.document_check_level_id = 1;
            this.language_id = 26;
            this.marketing_ratio_id = null;
            this.initial_marketing_ratio_id = null;
            this.sales_ratio_id = null;
            this.consolidation_type_id = 29;
            this.company_financials_address = "";
            this.company_financials_address2 = "";
            this.company_financials_zip_code = "";
            this.company_financials_country = 182;
            this.company_financials_county = null;
            this.company_financials_sector = "";
            this.company_financials_city = "";
            this.key_account_manager_id = null;
            this.double_order_refs_allowed = 1;
            this.reference_mandatory = 1;
            this.bank_no = "";
            this.bank_name = "";
            this.swift = "";
            this.bank_city_name = "";
            this.iban = "";
            this.sales_calculation_level_nd_shipment_id = 3;
            this.sales_calculation_level_ro_order_id = 7;
            this.currency_id = null;
            this.default_currency_id = null;
            this.default_invoicing_exchange_id = null;
            this.creditor_number = "Y";
            this.fuel_surcharge_method_id = 11;
            this.financial_date_determination_id = 28;
            this.default_val = 1;
            this.double_financials_ref_allowed = 1;
            this.request_debtor_no = 1;
            this.credit_check = 1;
            this.vat_country_code = null;
            this.vat_number = null;
            this.commerce_code = "";
            this.invoice_expire_date_method_id = null;
            this.invoice_expire_date_method_cr_id = 74;
            this.invoice_copies = 0;
            this.change_revenue_status_auto_to_toinv = 1;
            this.change_revenue_status_when_shipment_id = 13;
            this.print_specification = 1;
            this.pickup_delivery = 1;
            this.pickup = 1;
            this.transfer = 1;
            this.delivery = 1;
            this.status = 0;
            this.tms_road_api_status = 0;
            this.nps = "";
            this.business_category_id = null;
            this.industry_id = null;
            this.parent_account_id = null;
            this.website = "";
            this.description = "";
            this.company_type_id = null;
            this.payment_term_id = null;
            this.credit_limit = 0;
            this.credit_valute_id = 286;
            this.first_order_date = null;
            this.iff_first_order_date = null;
            this.sea_fcl_first_order_date = null;
            this.sea_lcl_first_order_date = null;
            this.air_first_order_date = null;
            this.distribution_first_order_date = null;
            this.strongo_first_order_date = null;
            this.logistics_first_order_date = null;
            this.simplify_first_order_date = null;
            this.createdAt = null;
            this.updatedAt = null;
            this.created_by_user = "";
            this.updated_by_user = "";
            this.due_date_type = 0;
            this.due_date_type_cr = 0;
            this.address2 = "";
            this.customer_reminder_email = "";
            this.reminder_term_id = null;
            this.role_id = 274;
            this.d394_county_code_id = null;
            this.saft_partner_type_id = null;
            this.customer_posting_group_id = null;
            this.vendor_posting_group_id = null;
            this.customer_gen_bus_posting_group_id = null;
            this.vendor_gen_bus_posting_group_id = null;
            this.customer_vat_bus_posting_group_id = null;
            this.vendor_vat_bus_posting_group_id = null;
            this.application_method_id = 343;
            this.sales_persons_code_id = null;
            this.vendor_send_payment_notif = 0;
            this.not_vat_registration = 0;
            this.applies_split_vatsys = 0;
            this.unrealized_vat_status = 0;
            this.customer_contract_no = "";
            this.tms_sea_email = "";
            this.tms_sea_telephone = "";
            this.wms_email = "";
            this.wms_telephone = "";
            this.vbs_email = "";
            this.vbs_telephone = "";
            this.erp_email = "";
            this.erp_telephone = "";
            this.strongo_email = "";
            this.strongo_telephone = "";
            this.payment_method_id = 2;
            this.is_active = 1;
            this.ticketing_external_id = null;
            this.sales_approved_at = null;
            this.financial_approved_at = null;
            this.international_order_entry = false;
            this.domestic_order_entry = false;
            this.strongo_order_entry = false;
            this.disable_erp_duplicate = false;
            this.transport_contract_enabled = false;
            this.warehousing_contract_enabled = false;
            this.partner_type_id = null;
            this.image_contents = '';
            this.image_type = '';
            this.bussinessLines = [];
            this.tmsRoles = [];
            this.companyTmsRoles = [];
            this.companyFeatures = [];
            this.companyBillingMethods = [];
            this.companyNotes = [];
            this.companyFiles = [];
            this.contacts = [];
            this.companyBusinessLines = [];
            this.companyBusinessLineDetails = [];
            this.userToCompanies = [];
            this.userToBusinessLines = [];
            this.internationalRoadOrderEntry = undefined;
            this.domesticRoadOrderEntry = undefined;
            this.strongoOrderEntry = undefined;
            this.companyStrongoSetting = new CompanyStrongoSetting();
            this.orderEntryLeadtimes = [];
            this.strongoLeadtimes = [];
            this.strongoDepartments = [];
            this.orderEntryEmails = [];
            this.companyContracts = [];
            this.activeCompanyContracts = [];
            this.companyKpis = [];
            this.companyAnnexes = [];
            this.contractManagers = [];
            this.parentAccount = null;
            this.accountReceivable = null;
            this.lastCustomerLedgerEntry = null;
            this.salesPerson = null;
            this.tmsRoadCreationDate = null;
            this.tmsSeaCreationDate = null;
            this.erpCreationDate = null;
            this.strongoCreationDate = null;
            this.lastPaymentNote = null;

        } else {
            this.id = data.id;
            this.tms_road_unique_code = data.tms_road_unique_code;
            this.tms_road_unique_fin_code = data.tms_road_unique_fin_code;
            this.blocked = data.blocked;
            this.client_mcp_blocked = data.client_mcp_blocked;
            this.blocking_reason = data.blocking_reason;
            this.erp_blocked_id = data.erp_blocked_id;
            this.allowed_modify = data.allowed_modify;
            this.responsibility_center_id = data.responsibility_center_id;
            this.do_not_block_until = null;
            if (data.do_not_block_until !== null) {
                this.do_not_block_until = new Date(data.do_not_block_until);
            }
            this.do_not_block_from = null;
            if (data.do_not_block_from !== null) {
                this.do_not_block_from = new Date(data.do_not_block_from);
            }
            this.name = data.name;
            this.image_data = data.image_data;
            this.address = data.address;
            this.country = data.country;
            this.city = data.city;
            this.zip_code = data.zip_code;
            this.county = data.county;
            this.sector = data.sector;
            this.telephone = data.telephone;
            this.mobile = data.mobile;
            this.email = data.email;
            this.contact_person = data.contact_person;
            this.document_check_level_id = data.document_check_level_id;
            this.language_id = data.language_id;
            this.marketing_ratio_id = data.marketing_ratio_id;
            this.initial_marketing_ratio_id = data.initial_marketing_ratio_id;
            this.sales_ratio_id = data.sales_ratio_id;
            this.key_account_manager_id = data.key_account_manager_id;
            this.double_order_refs_allowed = data.double_order_refs_allowed;
            this.reference_mandatory = data.reference_mandatory;
            this.bank_no = data.bank_no;
            this.bank_name = data.bank_name;
            this.swift = data.swift;
            this.bank_city_name = data.bank_city_name;
            this.iban = data.iban;
            this.sales_calculation_level_nd_shipment_id = data.sales_calculation_level_nd_shipment_id;
            this.sales_calculation_level_ro_order_id = data.sales_calculation_level_ro_order_id;
            this.consolidation_type_id = data.consolidation_type_id;
            this.company_financials_address = data.company_financials_address;
            this.company_financials_address2 = data.company_financials_address2;
            this.company_financials_zip_code = data.company_financials_zip_code;
            this.company_financials_country = data.company_financials_country;
            this.company_financials_county = data.company_financials_county;
            this.company_financials_sector = data.company_financials_sector;
            this.company_financials_city = data.company_financials_city;
            this.currency_id = data.currency_id;
            this.default_currency_id = data.default_currency_id;
            this.default_invoicing_exchange_id = data.default_invoicing_exchange_id;
            this.creditor_number = data.creditor_number;
            this.fuel_surcharge_method_id = data.fuel_surcharge_method_id;
            this.financial_date_determination_id = data.financial_date_determination_id;
            this.default_val = data.default_val;
            this.double_financials_ref_allowed = data.double_financials_ref_allowed;
            this.request_debtor_no = data.request_debtor_no;
            this.credit_check = data.credit_check;
            this.vat_country_code = data.vat_country_code;
            this.vat_number = data.vat_number;
            this.commerce_code = data.commerce_code;
            this.invoice_expire_date_method_id = data.invoice_expire_date_method_id;
            this.invoice_expire_date_method_cr_id = data.invoice_expire_date_method_cr_id;
            this.invoice_copies = data.invoice_copies;
            this.change_revenue_status_auto_to_toinv = data.change_revenue_status_auto_to_toinv;
            this.change_revenue_status_when_shipment_id = data.change_revenue_status_when_shipment_id;
            this.print_specification = data.print_specification;
            this.pickup_delivery = data.pickup_delivery;
            this.pickup = data.pickup;
            this.transfer = data.transfer;
            this.delivery = data.delivery;
            this.status = data.status;
            this.tms_road_api_status = data.tms_road_api_status;
            this.nps = data.nps;
            this.business_category_id = data.business_category_id;
            this.industry_id = data.industry_id;
            this.parent_account_id = data.parent_account_id;
            this.website = data.website;
            this.description = data.description;
            this.company_type_id = data.company_type_id;
            this.payment_term_id = data.payment_term_id;
            this.credit_limit = data.credit_limit;
            this.credit_valute_id = data.credit_valute_id;
            this.first_order_date = null;
            if (data.first_order_date !== null) {
                this.first_order_date = new Date(data.first_order_date);
            }
            this.iff_first_order_date = null;
            if (data.iff_first_order_date !== null) {
                this.iff_first_order_date = new Date(data.iff_first_order_date);
            }
            this.sea_fcl_first_order_date = null;
            if (data.sea_fcl_first_order_date !== null) {
                this.sea_fcl_first_order_date = new Date(data.sea_fcl_first_order_date);
            }
            this.sea_lcl_first_order_date = null;
            if (data.sea_lcl_first_order_date !== null) {
                this.sea_lcl_first_order_date = new Date(data.sea_lcl_first_order_date);
            }
            this.air_first_order_date = null;
            if (data.air_first_order_date !== null) {
                this.air_first_order_date = new Date(data.air_first_order_date);
            }
            this.distribution_first_order_date = null;
            if (data.distribution_first_order_date !== null) {
                this.distribution_first_order_date = new Date(data.distribution_first_order_date);
            }
            this.strongo_first_order_date = null;
            if (data.strongo_first_order_date !== null) {
                this.strongo_first_order_date = new Date(data.strongo_first_order_date);
            }
            this.logistics_first_order_date = null;
            if (data.logistics_first_order_date !== null) {
                this.logistics_first_order_date = new Date(data.logistics_first_order_date);
            }
            this.simplify_first_order_date = null;
            if (data.simplify_first_order_date !== null) {
                this.simplify_first_order_date = new Date(data.simplify_first_order_date);
            }
            this.createdAt = null;
            if (data.createdAt !== null) {
                this.createdAt = new Date(data.createdAt);
            }
            this.updatedAt = null;
            if (data.updatedAt !== null) {
                this.updatedAt = new Date(data.updatedAt);
            }
            this.created_by_user = data.created_by_user;
            this.updated_by_user = data.updated_by_user;
            this.due_date_type = data.due_date_type;
            this.due_date_type_cr = data.due_date_type_cr;
            this.address2 = data.address2;
            this.customer_reminder_email = data.customer_reminder_email;
            this.reminder_term_id = data.reminder_term_id;
            this.role_id = data.role_id;
            this.d394_county_code_id = data.d394_county_code_id;
            this.saft_partner_type_id = data.saft_partner_type_id;
            this.customer_posting_group_id = data.customer_posting_group_id;
            this.vendor_posting_group_id = data.vendor_posting_group_id;
            this.customer_gen_bus_posting_group_id = data.customer_gen_bus_posting_group_id;
            this.vendor_gen_bus_posting_group_id = data.vendor_gen_bus_posting_group_id;
            this.customer_vat_bus_posting_group_id = data.customer_vat_bus_posting_group_id;
            this.vendor_vat_bus_posting_group_id = data.vendor_vat_bus_posting_group_id;
            this.application_method_id = data.application_method_id;
            this.sales_persons_code_id = data.sales_persons_code_id;
            this.vendor_send_payment_notif = data.vendor_send_payment_notif;
            this.not_vat_registration = data.not_vat_registration;
            this.applies_split_vatsys = data.applies_split_vatsys;
            this.unrealized_vat_status = data.unrealized_vat_status;
            this.customer_contract_no = data.customer_contract_no;
            this.tms_sea_email = data.tms_sea_email;
            this.tms_sea_telephone = data.tms_sea_telephone;
            this.wms_email = data.wms_email;
            this.wms_telephone = data.wms_telephone;
            this.vbs_email = data.vbs_email;
            this.vbs_telephone = data.vbs_telephone;
            this.erp_email = data.erp_email;
            this.erp_telephone = data.erp_telephone;
            this.strongo_email = data.strongo_email;
            this.strongo_telephone = data.strongo_telephone;
            this.international_order_entry = data.international_order_entry;
            this.domestic_order_entry = data.domestic_order_entry;
            this.strongo_order_entry = data.strongo_order_entry;
            this.disable_erp_duplicate = data.disable_erp_duplicate;
            this.transport_contract_enabled = data.transport_contract_enabled;
            this.warehousing_contract_enabled = data.warehousing_contract_enabled;
            this.payment_method_id = data.payment_method_id;
            this.is_active = data.is_active;
            this.ticketing_external_id = data.ticketing_external_id;
            this.image_contents = data.image_contents;
            this.image_type = data.image_type;

            this.sales_approved_at = data.sales_approved_at;
            if (data.sales_approved_at !== null) {
                this.sales_approved_at = new Date(data.sales_approved_at);
            }
            this.financial_approved_at = data.financial_approved_at;
            if (data.financial_approved_at !== null) {
                this.financial_approved_at = new Date(data.financial_approved_at);
            }

            this.partner_type_id = data.partner_type_id;
            this.bussinessLines = [];
            if (data.bussinessLines !== undefined) {
                data.bussinessLines.forEach(bussinessLine => this.bussinessLines.push((new BussinessLine(bussinessLine))));
            }

            this.tmsRoles = [];
            if (data.tmsRoles !== undefined) {
                data.tmsRoles.forEach(tmsRole => this.tmsRoles.push((new TmsRole(tmsRole))));
            }

            this.companyTmsRoles = [];
            if (data.companyTmsRoles !== undefined) {
                data.companyTmsRoles.forEach(companyTmsRole => this.companyTmsRoles.push((new CompanyTmsRole(companyTmsRole))));
            }

            this.companyFeatures = [];
            if (data.companyFeatures !== undefined) {
                data.companyFeatures.forEach(companyFeature => this.companyFeatures.push((new CompanyFeature(companyFeature))));
            }

            this.companyBillingMethods = [];
            if (data.companyBillingMethods !== undefined) {
                data.companyBillingMethods.forEach(companyBillingMethod => this.companyBillingMethods.push((new CompanyBillingMethod(companyBillingMethod))));
            }
            this.companyNotes = [];
            if (data.companyNotes !== undefined) {
                data.companyNotes.forEach(companyNote => this.companyNotes.push((new CompanyNote(companyNote))));
            }
            this.companyFiles = [];
            if (data.companyFiles !== undefined) {
                data.companyFiles.forEach(companyFile => this.companyFiles.push((new CompanyFile(companyFile))));
            }
            this.contacts = [];
            if (data.contacts !== undefined) {
                data.contacts.forEach(contact => this.contacts.push((new Contact(contact))));
            }
            this.companyBusinessLines = [];
            if (data.companyBusinessLines !== undefined) {
                data.companyBusinessLines.forEach(companyBusinessLine => this.companyBusinessLines.push((new CompanyBusinessLine(companyBusinessLine))));
            }

            this.companyBusinessLineDetails = [];
            if (data.companyBusinessLineDetails !== undefined) {
                data.companyBusinessLineDetails.forEach(companyBusinessLineDetail => this.companyBusinessLineDetails.push((new CompanyBusinessLineDetail(companyBusinessLineDetail))));
            }

            this.userToCompanies = [];
            if (data.userToCompanies !== undefined) {
                data.userToCompanies.forEach(userToCompany => this.userToCompanies.push((new UserToCompany(userToCompany))));
            }

            this.userToBusinessLines = [];
            if (data.userToBusinessLines !== undefined) {
                data.userToBusinessLines.forEach(userToBusinessLine => this.userToBusinessLines.push((new UserToBusinessLine(userToBusinessLine))));
            }

            if (data.internationalRoadOrderEntry !== undefined && data.internationalRoadOrderEntry !== null) {
                this.internationalRoadOrderEntry = new InternationalRoadOrderEntry(data.internationalRoadOrderEntry);
            } else {
                this.internationalRoadOrderEntry = new InternationalRoadOrderEntry();
            }

            if (data.domesticRoadOrderEntry !== undefined && data.domesticRoadOrderEntry !== null) {
                this.domesticRoadOrderEntry = new DomesticRoadOrderEntry(data.domesticRoadOrderEntry);
            } else {
                this.domesticRoadOrderEntry = new DomesticRoadOrderEntry();
            }

            if (data.strongoOrderEntry !== undefined && data.strongoOrderEntry !== null) {
                this.strongoOrderEntry = new StrongoOrderEntry(data.strongoOrderEntry);
            } else {
                this.strongoOrderEntry = new StrongoOrderEntry();
            }
            if (data.companyStrongoSetting !== undefined && data.companyStrongoSetting !== null) {
                this.companyStrongoSetting = new CompanyStrongoSetting(data.companyStrongoSetting);
            } else {
                this.companyStrongoSetting = new CompanyStrongoSetting();
            }

            this.orderEntryLeadtimes = [];
            if (data.orderEntryLeadtimes !== undefined) {
                data.orderEntryLeadtimes.forEach(orderEntryLeadtime => this.orderEntryLeadtimes.push((new OrderEntryLeadtime(orderEntryLeadtime))));
            }

            this.strongoLeadtimes = [];
            if (data.strongoLeadtimes !== undefined) {
                data.strongoLeadtimes.forEach(strongoLeadtime => this.strongoLeadtimes.push((new StrongoOrderEntryLeadtime(strongoLeadtime))));
            }

            this.strongoDepartments = [];
            if (data.strongoDepartments !== undefined) {
                data.strongoDepartments.forEach(strongoDepartment => this.strongoDepartments.push((new StrongoDepartment(strongoDepartment))));
            }

            this.orderEntryEmails = [];
            if (data.orderEntryEmails !== undefined) {
                data.orderEntryEmails.forEach(orderEntryEmail => this.orderEntryEmails.push((new OrderEntryEmail(orderEntryEmail))));
            }

            this.companyContracts = [];
            if (data.companyContracts !== undefined) {
                data.companyContracts.forEach(companyContract => this.companyContracts.push((new CompanyContract(companyContract))));
            }

            this.activeCompanyContracts = [];
            if (data.activeCompanyContracts !== undefined) {
                data.activeCompanyContracts.forEach(activeCompanyContract => this.activeCompanyContracts.push((new CompanyContract(activeCompanyContract))));
            }

            this.companyKpis = [];
            if (data.companyKpis !== undefined) {
                data.companyKpis.forEach(companyKpi => this.companyKpis.push((new CompanyKpi(companyKpi))));
            }

            this.companyAnnexes = [];
            if (data.companyAnnexes !== undefined) {
                data.companyAnnexes.forEach(companyAnnex => this.companyAnnexes.push((new CompanyAnnex(companyAnnex))));
            }

            this.contractManagers = [];
            if (data.contractManagers !== undefined) {
                data.contractManagers.forEach(contractManager => this.contractManagers.push((new User(contractManager))));
            }
            if (data.parentAccount !== undefined && data.parentAccount !== null) {
                this.parentAccount = new Company(data.parentAccount);
            } else {
                this.parentAccount = null;
            }
            if (data.accountReceivable !== undefined && data.accountReceivable !== null) {
                this.accountReceivable = new AccountReceivable(data.accountReceivable);
            } else {
                this.accountReceivable = null;
            }
            if (data.lastCustomerLedgerEntry !== undefined && data.lastCustomerLedgerEntry !== null) {
                this.lastCustomerLedgerEntry = new CustomerLedgerEntry(data.lastCustomerLedgerEntry);
            } else {
                this.lastCustomerLedgerEntry = null;
            }
            if (data.salesPerson !== undefined && data.salesPerson !== null) {
                this.salesPerson = new User(data.salesPerson);
            } else {
                this.salesPerson = null;
            }
            if (data.tmsRoadCreationDate !== undefined && data.tmsRoadCreationDate !== null) {
                this.tmsRoadCreationDate = new TmsRoad(data.tmsRoadCreationDate);
            } else {
                this.tmsRoadCreationDate = null;
            }
            if (data.tmsSeaCreationDate !== undefined && data.tmsSeaCreationDate !== null) {
                this.tmsSeaCreationDate = new TmsSea(data.tmsSeaCreationDate);
            } else {
                this.tmsSeaCreationDate = null;
            }
            if (data.erpCreationDate !== undefined && data.erpCreationDate !== null) {
                this.erpCreationDate = new ERP(data.erpCreationDate);
            } else {
                this.erpCreationDate = null;
            }
            if (data.strongoCreationDate !== undefined && data.strongoCreationDate !== null) {
                this.strongoCreationDate = new Strongo(data.strongoCreationDate);
            } else {
                this.strongoCreationDate = null;
            }
            if (data.lastPaymentNote !== undefined && data.lastPaymentNote !== null) {
                this.lastPaymentNote = new CompanyNote(data.lastPaymentNote);
            } else {
                this.lastPaymentNote = null;
            }
        }
    }

    uniqueCodeContains(search: string) {
        if (this.tms_road_unique_code === null) {
            return false;
        }

        return this.tms_road_unique_code.trim().toLowerCase().indexOf(search.trim().toLowerCase()) >= 0;
    }

    nameContains(search: string) {
        return this.name.trim().toLowerCase().indexOf(search.trim().toLowerCase()) >= 0;
    }

    emailContains(search: string) {
        return this.email.trim().toLowerCase().indexOf(search.trim().toLowerCase()) >= 0;
    }

    locationContains(search: string) {
        if (this.city === null) {
            return false;
        }

        return this.city.trim().toLowerCase().indexOf(search.trim().toLowerCase()) >= 0;
    }

    phoneContains(search: string) {
        return this.telephone.toString().trim().toLowerCase().indexOf(search.trim().toLowerCase()) >= 0;
    }

    getLogo(): string | null {
        return `data:${this.image_type};base64,${this.image_contents}`;
    }

    serializeData(without_relations: boolean | Array<string> = false, with_relations: boolean | Array<string> = false, ids_only: boolean = false) {
        const serialized_data = {
            id: this.id,
            tms_road_unique_code: this.tms_road_unique_code,
            tms_road_unique_fin_code: this.tms_road_unique_fin_code,
            blocked: this.blocked,
            client_mcp_blocked: this.client_mcp_blocked,
            blocking_reason: this.blocking_reason,
            erp_blocked_id: this.erp_blocked_id,
            allowed_modify: this.allowed_modify,
            responsibility_center_id: this.responsibility_center_id,
            do_not_block_until: this.do_not_block_until,
            do_not_block_from: this.do_not_block_from,
            name: this.name,
            image_data: this.image_data,
            address: this.address,
            country: this.country,
            city: this.city,
            zip_code: this.zip_code,
            county: this.county,
            sector: this.sector,
            telephone: this.telephone,
            mobile: this.mobile,
            email: this.email,
            contact_person: this.contact_person,
            document_check_level_id: this.document_check_level_id,
            language_id: this.language_id,
            marketing_ratio_id: this.marketing_ratio_id,
            initial_marketing_ratio_id: this.initial_marketing_ratio_id,
            sales_ratio_id: this.sales_ratio_id,
            key_account_manager_id: this.key_account_manager_id,
            double_order_refs_allowed: this.double_order_refs_allowed,
            reference_mandatory: this.reference_mandatory,
            bank_no: this.bank_no,
            bank_name: this.bank_name,
            swift: this.swift,
            bank_city_name: this.bank_city_name,
            iban: this.iban,
            sales_calculation_level_nd_shipment_id: this.sales_calculation_level_nd_shipment_id,
            sales_calculation_level_ro_order_id: this.sales_calculation_level_ro_order_id,
            currency_id: this.currency_id,
            default_currency_id: this.default_currency_id,
            default_invoicing_exchange_id: this.default_invoicing_exchange_id,
            creditor_number: this.creditor_number,
            fuel_surcharge_method_id: this.fuel_surcharge_method_id,
            financial_date_determination_id: this.financial_date_determination_id,
            default_val: this.default_val,
            double_financials_ref_allowed: this.double_financials_ref_allowed,
            consolidation_type_id: this.consolidation_type_id,
            company_financials_address: this.company_financials_address,
            company_financials_address2: this.company_financials_address2,
            company_financials_zip_code: this.company_financials_zip_code,
            company_financials_country: this.company_financials_country,
            company_financials_county: this.company_financials_county,
            company_financials_sector: this.company_financials_sector,
            company_financials_city: this.company_financials_city,
            request_debtor_no: this.request_debtor_no,
            credit_check: this.credit_check,
            vat_country_code: this.vat_country_code,
            vat_number: this.vat_number,
            commerce_code: this.commerce_code,
            invoice_expire_date_method_id: this.invoice_expire_date_method_id,
            invoice_expire_date_method_cr_id: this.invoice_expire_date_method_cr_id,
            invoice_copies: this.invoice_copies,
            change_revenue_status_auto_to_toinv: this.change_revenue_status_auto_to_toinv,
            change_revenue_status_when_shipment_id: this.change_revenue_status_when_shipment_id,
            print_specification: this.print_specification,
            pickup_delivery: this.pickup_delivery,
            pickup: this.pickup,
            transfer: this.transfer,
            delivery: this.delivery,
            status: this.status,
            tms_road_api_status: this.tms_road_api_status,
            nps: this.nps,
            business_category_id: this.business_category_id,
            industry_id: this.industry_id,
            parent_account_id: this.parent_account_id,
            website: this.website,
            description: this.description,
            company_type_id: this.company_type_id,
            payment_term_id: this.payment_term_id,
            credit_limit: this.credit_limit,
            credit_valute_id: this.credit_valute_id,
            first_order_date: this.first_order_date,
            iff_first_order_date: this.iff_first_order_date,
            sea_fcl_first_order_date: this.sea_fcl_first_order_date,
            sea_lcl_first_order_date: this.sea_lcl_first_order_date,
            air_first_order_date: this.air_first_order_date,
            distribution_first_order_date: this.distribution_first_order_date,
            strongo_first_order_date: this.strongo_first_order_date,
            logistics_first_order_date: this.logistics_first_order_date,
            simplify_first_order_date: this.simplify_first_order_date,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
            created_by_user: this.created_by_user,
            updated_by_user: this.updated_by_user,
            due_date_type: this.due_date_type,
            due_date_type_cr: this.due_date_type_cr,
            address2: this.address2,
            customer_reminder_email: this.customer_reminder_email,
            reminder_term_id: this.reminder_term_id,
            role_id: this.role_id,
            d394_county_code_id: this.d394_county_code_id,
            saft_partner_type_id: this.saft_partner_type_id,
            customer_posting_group_id: this.customer_posting_group_id,
            vendor_posting_group_id: this.vendor_posting_group_id,
            customer_gen_bus_posting_group_id: this.customer_gen_bus_posting_group_id,
            vendor_gen_bus_posting_group_id: this.vendor_gen_bus_posting_group_id,
            customer_vat_bus_posting_group_id: this.customer_vat_bus_posting_group_id,
            vendor_vat_bus_posting_group_id: this.vendor_vat_bus_posting_group_id,
            application_method_id: this.application_method_id,
            sales_persons_code_id: this.sales_persons_code_id,
            vendor_send_payment_notif: this.vendor_send_payment_notif,
            not_vat_registration: this.not_vat_registration,
            applies_split_vatsys: this.applies_split_vatsys,
            unrealized_vat_status: this.unrealized_vat_status,
            customer_contract_no: this.customer_contract_no,
            tms_sea_email: this.tms_sea_email,
            tms_sea_telephone: this.tms_sea_telephone,
            wms_email: this.wms_email,
            wms_telephone: this.wms_telephone,
            vbs_email: this.vbs_email,
            vbs_telephone: this.vbs_telephone,
            erp_email: this.erp_email,
            erp_telephone: this.erp_telephone,
            strongo_email: this.strongo_email,
            strongo_telephone: this.strongo_telephone,
            payment_method_id: this.payment_method_id,
            is_active: this.is_active,
            ticketing_external_id: this.ticketing_external_id,
            international_order_entry: this.international_order_entry,
            domestic_order_entry: this.domestic_order_entry,
            strongo_order_entry: this.strongo_order_entry,
            disable_erp_duplicate: this.disable_erp_duplicate,
            transport_contract_enabled: this.transport_contract_enabled,
            warehousing_contract_enabled: this.warehousing_contract_enabled,
            partner_type_id: this.partner_type_id,
        }

        // return company_data;

        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('bussinessLines')
            )
        ) {
            serialized_data.bussinessLines = [];
            this.bussinessLines.forEach(el => {
                serialized_data.bussinessLines.push(el.serializeData())
            })
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('tmsRoles')
            )
        ) {
            serialized_data.tmsRoles = [];
            this.tmsRoles.forEach(el => {
                serialized_data.tmsRoles.push(el.serializeData())
            })
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companyTmsRoles')
            )
        ) {
            serialized_data.companyTmsRoles = [];
            this.companyTmsRoles.forEach(el => {
                serialized_data.companyTmsRoles.push(el.serializeData())
            })
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companyFeatures')
            )
        ) {
            serialized_data.companyFeatures = [];
            this.companyFeatures.forEach(el => {
                serialized_data.companyFeatures.push(el.serializeData())
            })
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companyBillingMethods')
            )
        ) {
            serialized_data.companyBillingMethods = [];
            this.companyBillingMethods.forEach(el => {
                serialized_data.companyBillingMethods.push(el.serializeData())
            })
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companyBusinessLines')
            )
        ) {
            serialized_data.companyBusinessLines = [];
            this.companyBusinessLines.forEach(el => {
                serialized_data.companyBusinessLines.push(el.serializeData())
            })
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companyBusinessLineDetails')
            )
        ) {
            serialized_data.companyBusinessLineDetails = [];
            this.companyBusinessLineDetails.forEach(el => {
                serialized_data.companyBusinessLineDetails.push(el.serializeData())
            })
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companyNotes')
            )
        ) {
            serialized_data.companyNotes = [];
            this.companyNotes.forEach(el => {
                serialized_data.companyNotes.push(el.serializeData())
            })

        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companyFiles')
            )
        ) {
            serialized_data.companyFiles = [];
            this.companyFiles.forEach(el => {
                serialized_data.companyFiles.push(el.serializeData())
            })

        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('contacts')
            )
        ) {
            serialized_data.contacts = [];
            this.contacts.forEach(el => {
                serialized_data.contacts.push(el.serializeData())
            })
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('internationalRoadOrderEntry')
            )
        ) {
            serialized_data.internationalRoadOrderEntry = {};
            this.internationalRoadOrderEntry?.serializeData();

        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('domesticRoadOrderEntry')
            )
        ) {
            serialized_data.domesticRoadOrderEntry = {};
            this.domesticRoadOrderEntry?.serializeData();

        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('strongoOrderEntry')
            )
        ) {
            serialized_data.strongoOrderEntry = {};
            this.strongoOrderEntry?.serializeData();

        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companyStrongoSetting')
            )
        ) {
            serialized_data.companyStrongoSetting = this.companyStrongoSetting.serializeData();
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('orderEntryLeadtimes')
            )
        ) {
            serialized_data.orderEntryLeadtimes = [];
            this.orderEntryLeadtimes.forEach(el => {
                serialized_data.orderEntryLeadtimes.push(el.serializeData())
            })
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('strongoLeadtimes')
            )
        ) {
            serialized_data.strongoLeadtimes = [];
            this.strongoLeadtimes.forEach(el => {
                serialized_data.strongoLeadtimes.push(el.serializeData())
            })
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('orderEntryEmails')
            )
        ) {
            serialized_data.orderEntryEmails = [];
            this.orderEntryEmails.forEach(el => {
                serialized_data.orderEntryEmails.push(el.serializeData())
            })
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companyContracts')
            )
        ) {
            serialized_data.companyContracts = [];
            this.companyContracts.forEach(el => {
                serialized_data.companyContracts.push(el.serializeData())
            })
        }

        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('activeCompanyContracts')
            )
        ) {
            serialized_data.activeCompanyContracts = [];
            this.activeCompanyContracts.forEach(el => {
                serialized_data.activeCompanyContracts.push(el.serializeData())
            })
        }

        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companyKpis')
            )
        ) {
            serialized_data.companyKpis = [];
            this.companyKpis.forEach(el => {
                serialized_data.companyKpis.push(el.serializeData())
            })
        }

        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('companyAnnexes')
            )
        ) {
            serialized_data.companyAnnexes = [];
            this.companyAnnexes.forEach(el => {
                serialized_data.companyAnnexes.push(el.serializeData())
            })
        }

        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('contractManagers')
            ) ||
            (
                Array.isArray(with_relations) &&
                with_relations.includes('contractManagers')
            )

        ) {
            serialized_data.contractManagers = [];
            this.contractManagers.forEach(el => {
                if (ids_only === true) {
                    serialized_data.contractManagers.push({id: el.id})
                } else {
                    if (el instanceof User && typeof el.serializeData === "function") {
                        serialized_data.contractManagers.push(el.serializeData())
                    } else {
                        serialized_data.contractManagers.push(el)
                    }
                }
            })
        }

        return serialized_data;
    }

}

export type CompanyData = {
    id: number | null;
    tms_road_unique_code: string | null;
    tms_road_unique_fin_code: string | null;
    blocked: number | null;
    client_mcp_blocked: number | null;
    erp_blocked_id: number | null;
    allowed_modify: boolean;
    responsibility_center_id: number | null;
    do_not_block_until: Date | null;
    do_not_block_from: Date | null;
    blocking_reason: string;
    name: string;
    image_data: string | null,
    address: string;
    country: number | null;
    city: string | null;
    zip_code: string;
    county: string | null;
    sector: string;
    telephone: string;
    mobile: string;
    email: string;
    contact_person: string;
    document_check_level_id: number | null;
    language_id: number | null;
    marketing_ratio_id: number | null;
    initial_marketing_ratio_id: number | null;
    sales_ratio_id: number | null;
    key_account_manager_id: number | null;
    double_order_refs_allowed: number;
    reference_mandatory: number;
    bank_no: string;
    bank_name: string;
    swift: string;
    bank_city_name: string;
    iban: string;
    sales_calculation_level_nd_shipment_id: number | null;
    sales_calculation_level_ro_order_id: number | null;
    currency_id: number | null;
    default_currency_id: number | null;
    default_invoicing_exchange_id: number | null;
    creditor_number: string;
    fuel_surcharge_method_id: number | null;
    financial_date_determination_id: number | null;
    default_val: number;
    consolidation_type_id: number | null;
    company_financials_address: string;
    company_financials_address2: string;
    company_financials_zip_code: string;
    company_financials_country: number;
    company_financials_county: string | null;
    company_financials_sector: string;
    company_financials_city: string;
    double_financials_ref_allowed: number;
    request_debtor_no: number;
    credit_check: number;
    vat_country_code: string;
    vat_number: string | null;
    commerce_code: string;
    invoice_expire_date_method_id: number | null;
    invoice_expire_date_method_cr_id: number | null;
    invoice_copies: number;
    change_revenue_status_auto_to_toinv: number;
    change_revenue_status_when_shipment_id: number | null;
    print_specification: number;
    pickup_delivery: number;
    pickup: number;
    transfer: number;
    delivery: number;
    status: number;
    tms_road_api_status: number;
    nps: string | null;
    business_category_id: number | null;
    industry_id: number | null;
    parent_account_id: number | null;
    website: string | null;
    description: string | null;
    company_type_id: number | null;
    payment_term_id: number | null;
    credit_limit: number | null;
    credit_valute_id: number | null;
    first_order_date: Date | null;
    iff_first_order_date: Date | null;
    sea_fcl_first_order_date: Date | null;
    sea_lcl_first_order_date: Date | null;
    air_first_order_date: Date | null;
    distribution_first_order_date: Date | null;
    strongo_first_order_date: Date | null;
    logistics_first_order_date: Date | null;
    simplify_first_order_date: Date | null;
    createdAt: Date | null;
    updatedAt: Date | null;
    created_by_user: string;
    updated_by_user: string;
    due_date_type: number | null;
    due_date_type_cr: number | null;
    address2: string;
    customer_reminder_email: string;
    reminder_term_id: number | null;
    role_id: number | null;
    d394_county_code_id: number | null;
    saft_partner_type_id: number | null;
    customer_posting_group_id: number | null;
    vendor_posting_group_id: number | null;
    customer_gen_bus_posting_group_id: number | null;
    vendor_gen_bus_posting_group_id: number | null;
    customer_vat_bus_posting_group_id: number | null;
    vendor_vat_bus_posting_group_id: number | null;
    application_method_id: number | null;
    sales_persons_code_id: number | null;
    vendor_send_payment_notif: number | null;
    not_vat_registration: number | null;
    applies_split_vatsys: number | null;
    unrealized_vat_status: number | null;
    customer_contract_no: string;
    tms_sea_email: string;
    tms_sea_telephone: string;
    wms_email: string;
    wms_telephone: string;
    vbs_email: string;
    vbs_telephone: string;
    erp_email: string;
    erp_telephone: string;
    strongo_email: string;
    strongo_telephone: string;
    payment_method_id: number | null;
    is_active: number | null;
    ticketing_external_id: number | null;
    sales_approved_at: Date | null;
    financial_approved_at: Date | null;
    international_order_entry: boolean;
    domestic_order_entry: boolean;
    strongo_order_entry: boolean;
    disable_erp_duplicate: boolean;
    transport_contract_enabled: boolean;
    warehousing_contract_enabled: boolean;
    partner_type_id: number | null;
    image_contents:string;
    image_type:string;
    bussinessLines: BussinessLineData[] | undefined;
    tmsRoles: TmsRoleData[] | undefined;
    companyTmsRoles: CompanyTmsRoleData[] | undefined;
    companyFeatures: CompanyFeatureData[] | undefined;
    companyBillingMethods: CompanyBillingMethodData[] | undefined;
    companyNotes: CompanyNoteData[];
    companyFiles: CompanyFileData[];
    contacts: Contact[] | undefined;
    companyBusinessLines: CompanyBusinessLineData[];
    companyBusinessLineDetails: CompanyBusinessLineDetailData[];
    userToCompanies: UserToCompanyData[];
    userToBusinessLines: UserToBusinessLineData[];
    internationalRoadOrderEntry: InternationalRoadOrderEntryData | undefined;
    domesticRoadOrderEntry: DomesticRoadOrderEntryData;
    strongoOrderEntry: StrongoOrderEntryData;
    companyStrongoSetting: CompanyStrongoSettingData | undefined;
    orderEntryLeadtimes: OrderEntryLeadtimeData[];
    strongoLeadtimes: StrongoOrderEntryLeadtimeData[];
    strongoDepartments: StrongoDepartmentData[];
    orderEntryEmails: OrderEntryEmailData[];
    companyContracts: CompanyContractData[];
    activeCompanyContracts: CompanyContractData[];
    companyKpis: CompanyKpiData[];
    companyAnnexes: CompanyAnnexData[];
    contractManagers: UserData[];
    parentAccount: CompanyData | null | undefined;
    accountReceivable: AccountReceivableData | null | undefined;
    lastCustomerLedgerEntry: CustomerLedgerEntryData | null | undefined;
    salesPerson: UserData | null | undefined;
    tmsRoadCreationDate: TmsRoadData | null | undefined;
    tmsSeaCreationDate: TmsSeaData | null | undefined;
    erpCreationDate: ERPData | null | undefined;
    strongoCreationDate: StrongoData | null | undefined;
    lastPaymentNote: CompanyNoteData | null | undefined;

}

